<template>
	<div id="app">
		<div v-if="isInternetExplorer" class="flex flex_center" style="height:100vh; font-size: 18px; padding: 0 20px;">
			<span>{{ $t('common.outdatedBrowser.warning')}}</span>
		</div>
		<div v-else>
			<div :class="pdfDialogShow ? 'router_view' : ''">
				<router-view/>
			</div>
			<notifications></notifications>
			<EditPdfDialog v-if="pdfDialogShow"></EditPdfDialog>
			<ModalTem></ModalTem>
		</div>
	</div>
</template>

<script>
import {commonApi} from "@/common/api/commonApi";
import {SessionStorage} from "@/common/util";
import {setToken} from "@/common/utils/auth"; // getToken from cookie
import EditPdfDialog from "@/components/templates/seller/EditPdfDialog.vue";
import ModalTem from "@/components/templates/modal/ModalTem.vue";

import {mapActions, mapGetters} from "vuex";
import {localization} from "@/common/lang/localization";

export default {
	components: { EditPdfDialog, ModalTem },
	metaInfo() {
		return {
			htmlAttrs: {
				lang: localization.currentLocale()
			},
		};
	},
	beforeMount() {
		this.currentuser();
		this.getToken();
	},
	methods: {
		...mapActions(["setActionLoggedIn"]),
    currentuser() {
      let localeUser = this.$sessionStorage.get("localeUser");

      if (localeUser && localeUser.userId > 0) {
        this.currentuserSession(localeUser);
      } else {
        commonApi
            .Currentuser()
            .then(res => {
              this.currentuserSession(res);
            })
            .catch(err => {
              console.log("err", err);
            });
      }
    },
    currentuserSession(res) {
      if (typeof res.backendVersion !== 'undefined') {
        SessionStorage.set("backendVersion", res.backendVersion);
      }
      if (typeof res.userId !== 'undefined' && res.userId > 0) {
        this.setActionLoggedIn(true);
      }
    },
		getToken() {
			commonApi.getToken()
				.then(res => {
					setToken(res);
				});
		},
	},
	computed: {
    	...mapGetters({ pdfDialogShow: "pdfDialogShow", step: "step" }),
		isInternetExplorer() {
			return !!window.ActiveXObject || "ActiveXObject" in window;
		}
	},
};
</script>
